<template>
  <tr>
    <th class="w-52 px-4! py-2!">
      <RfSortButton
        :filtered="sort.type === 'timestamp' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'timestamp', value })"
      >
        Tag title
      </RfSortButton>
    </th>
    <th class="w-40 px-4! py-2!">
      <RfSortButton
        :filtered="sort.type === 'user_id' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'user_id', value })"
      >
        Creator
      </RfSortButton>
    </th>
    <th class="min-w-40 px-4! py-2!">
      <RfSortButton
        :filtered="sort.type === 'prompt_name' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'prompt_name', value })"
      >
        Description
      </RfSortButton>
    </th>
    <th class="w-20 px-4! py-2!">
      <RfSortButton
        :filtered="sort.type === 'connector' ? sort.value : null"
        class="h-full w-full justify-center"
        disabled
        @click="value => emit('update:sort', { type: 'connector', value })"
      >
        Color
      </RfSortButton>
    </th>
    <th class="w-6 px-4! py-2!"></th>
  </tr>
</template>

<script setup>
import RfSortButton from "@/components/buttons/RfSortButton.vue";

defineProps({ sort: { type: Object, default: null } });
const emit = defineEmits(["update:sort"]);
</script>
